import addInfoBarMessage from './addInfoBarMessage';
import showCcWell from './showCcWell';
import datapoints from '../datapoints';
import { findComposePlugins } from '../plugins/ComposePlugins';
import { ComposeViewState } from 'owa-mail-compose-store';
import convertInlineCssForHtml from '../utils/convertInlineCssForHtml';
import createAppendOnSendBlock from '../utils/createAppendOnSendBlock';
import { isPublicFolderComposeViewState } from '../utils/createPublicFolderComposeViewState';
import getFromViewState from '../utils/getFromViewState';
import shouldAlwaysShowFrom from '../utils/shouldAlwaysShowFrom';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { getBottomDockingHeight, updateDockingHeight } from 'owa-editor-docking-plugin';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default createLegacyActionWithDatapoint('upConvert', datapoints.MailComposeUpConvert)(
    function upConvert(viewState: ComposeViewState) {
        if (viewState.bodyType == 'HTML') {
            viewState.isRibbonShown = true;
        }

        const plugins = findComposePlugins(viewState);
        if (plugins) {
            if (plugins.undo) {
                plugins.undo.clear();
            }

            const contentOperationPlugin = plugins.contentOperationPlugin;
            if (contentOperationPlugin) {
                contentOperationPlugin.updateContentToViewState();
                contentOperationPlugin.stopSaveOnDispose();
            }
        }

        if (viewState.quotedBody) {
            // Clean global CSS and convert to inline CSS if any, so that global CSS will not impact new content
            const quotedBody = convertInlineCssForHtml(viewState.quotedBody, viewState.bodyType);
            viewState.content =
                viewState.content + createAppendOnSendBlock(viewState.bodyType) + quotedBody;
            viewState.useSmartResponse = false;
        } else if (viewState.lastSavedMessageBody) {
            viewState.content = convertInlineCssForHtml(
                viewState.lastSavedMessageBody,
                viewState.bodyType
            );
            viewState.useSmartResponse = false;
        } else {
            addInfoBarMessage(viewState, 'warningNoQuotedBody');
        }

        viewState.isInlineCompose = false;

        if (shouldAlwaysShowFrom()) {
            // When upconverting from inline compose, we need to re-initialize the from well view state.
            // This is because certain properties remain unset on purpose (to try to minimize when the well is visible unexpectedly)
            viewState.fromViewState = getFromViewState(
                viewState.fromViewState.from ? viewState.fromViewState.from.email : null,
                viewState.meetingRequestItem,
                viewState.referenceItemId,
                isPublicFolderComposeViewState(viewState),
                viewState.fromViewState.isFromShown
            );
        }

        if (!isConsumer()) {
            showCcWell(viewState);
        }

        updateDockingHeight(
            viewState.docking,
            getBottomDockingHeight(viewState.isRibbonShown, viewState.isInlineCompose)
        );
    }
);
